import { render, staticRenderFns } from "./accountTHINK.vue?vue&type=template&id=51833202&scoped=true&"
import script from "./accountTHINK.vue?vue&type=script&lang=js&"
export * from "./accountTHINK.vue?vue&type=script&lang=js&"
import style0 from "./accountTHINK.vue?vue&type=style&index=0&id=51833202&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51833202",
  null
  
)

export default component.exports